import * as React from "react"
import type { ButtonProps } from "@chakra-ui/react"
import { IconButton as ChakraIconButton, Icon } from "@chakra-ui/react"
import { IoCloseSharp } from "react-icons/io5"
import { LuX } from "react-icons/lu"

export type CloseButtonProps = ButtonProps & {
  iconProps?: React.ComponentProps<typeof Icon>;
}

export const CloseButton = React.forwardRef<
  HTMLButtonElement,
  CloseButtonProps
>(function CloseButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Close" ref={ref} {...props}>
      {props.children ?? <Icon boxSize={6} {...props.iconProps}><IoCloseSharp /></Icon>}
    </ChakraIconButton>
  )
})
